import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";

import "isomorphic-fetch";
import { polyfill } from "es6-promise";
import {
  OFLC_UPDATE_USER_ROLE,
  updateUserRoleSuccess,
  updateUserRoleFail,
} from "../actions/actions_updateUserRole";
import util from "../../../global/utils/Helpers";
import { store } from "../../../global/app/store";
polyfill();

let apiIndex = util.isLocalhost()
  ? "http://localhost:9393/auth/graphql"
  : `${util.getCurrentHost()}/auth/auth/graphql`;

const getQuery = ({ thisMember }) => {
  let state = store.getState();
  let currtUser = state.appReducer.userDataReducer.data;
  return JSON.stringify({
    query: `mutation {
			setAccountRole(
			  group_id: "${currtUser.Group.id}"
			  requestor: "${currtUser.subject}"
			  recipient: "${thisMember.subjectId}"
			  recipient_email: "${thisMember.email}"
			  role: "${thisMember.inputValue}"
			)
		  }`,
  });
};
const updateUserRoleEpic = (action$) =>
  action$.pipe(
    ofType(OFLC_UPDATE_USER_ROLE),
    mergeMap((action) =>
      fetch(apiIndex, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: getQuery(action.payload),
      })
        .then((response) => response.json())
        .then((data) => updateUserRoleSuccess(data))
        .catch((error) => updateUserRoleFail(true))
    )
  );

export default updateUserRoleEpic;
